<template>
  <div class="conversation-items d-flex position-relative" ref="menuContainerRef" @contextmenu.self.prevent="closeContextMenu">
    <transition name="indicator-fade">
      <div
        v-if="showNewMessagesIndicator"
        class="new-messages-indicator"
        @click="scrollToNewMessages"
      >
        <i class="fa fa-chevron-down mr-1"></i>
        {{ unreadMessagesCount }}
      </div>
    </transition>
    
    <transition name="ctx-blur">
      <div v-if="ctxMenu.visible" class="msg-ctx-blur-layer" @click="closeContextMenu" @contextmenu.prevent="closeContextMenu"></div>
    </transition>

    <div class="wrapper-items w-100" ref="containerRef">
      <div class="items" ref="itemsRef">
        <div v-for="(group, gIdx) in grouped" :key="gIdx" class="message-group">
          <div class="date">
            <span>{{ group.display_date }}</span>
          </div>
          <TransitionGroup name="message" tag="div">
            <div v-for="item in group.messages" :key="item.id"
                 v-memo="[item, props.selectionMode, props.selectedIds?.has(String(item.id)), ctxMenu.visible && String(ctxMenu.item?.id) === String(item.id), highlightedId !== null && String(highlightedId) === String(item.id)]"
                 class="item"
                 :class="[getAngularTypeClass(item), getItemClasses(item), { 'ctx-menu-active': ctxMenu.visible && String(ctxMenu.item?.id) === String(item.id), 'item-deleted': item._deletedLocally }]"
                 :data-status="item.status || 'delivered'"
                 :data-msg-id="item.id"
                 @click.left="onMsgLeftClick(item, $event)"
                 @contextmenu.prevent="onMsgRightClick(item, $event)"
                 @touchstart.passive="onMsgTouchStart(item, $event)"
                 @touchend="onMsgTouchEnd(item, $event)"
                 @touchmove.passive="onMsgTouchMove"
                 @wheel.passive="onWheel">
              <div class="item-body d-flex flex-row align-items-center" :class="{ 'flex-row-reverse': item.type === 'sent' }">
                <span class="avatar"
                  :style="getAvatarStyle(item)"
                ></span>
                <!-- Текст и медиа в одной колонке: при тексте+фото фото сверху (order), текст под ними -->
                <div class="item-content d-flex flex-column">
                <template v-for="gift in [parseGiftMessage(item.text)]" :key="item.id">
                  <template v-if="gift.isGift">
                    <div class="gift-message-card rounded">
                      <div class="gift-message-image">
                        <img :src="gift.parsed.gift_image" :alt="gift.parsed.gift_title" />
                      </div>
                      <div class="gift-message-info">
                        <div class="gift-message-title">🎁 {{ gift.parsed.gift_title }}</div>
                        <div v-if="gift.parsed.gift_message" class="gift-message-text text-muted small">
                          {{ gift.parsed.gift_message }}
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="item.text?.length">
                    <div
                      class="text p-2 rounded position-relative"
                  :class="[
                    item.type === 'sent' ? 'bg-azure text-white' : 'bg-gray-lightest text-gray-dark',
                    { 'bg-gray-lightest text-gray-dark': item._deletedLocally && item.type !== 'sent', 'message-deleted': item._deletedLocally }
                  ]"
                >
                  <small
                    v-if="item.is_edited"
                    :class="['d-block', 'edited-indicator', item.type === 'sent' ? 'text-light' : 'text-gray']"
                  >
                    {{ t('messages.changed') }}
                  </small>
                  <div v-if="item.reactions?.length" class="msg-top-reactions">
                    <template v-for="(r, idx) in getTopReactions(item.reactions)" :key="r.emoji">
                      <span
                        class="msg-reaction-small"
                        :class="{ 'msg-reaction-mine': r.user_ids?.includes(currentUserId) }"
                        @click.stop="onReact(r.emoji, item)"
                      >{{ r.emoji }}<span v-if="r.count > 1" class="msg-reaction-count">{{ r.count }}</span></span>
                      <span v-if="idx === 1 && item.reactions.length > 2" class="msg-reaction-more" @click.stop="openContextMenu(item)">+{{ item.reactions.length - 2 }}</span>
                    </template>
                  </div>
                  <!-- Цитата поста: ответ на публикацию ленты (message.post_id → item.post) -->
                  <div v-if="item.post" class="msg-quote post-quote">
                    <img v-if="item.post.photo" class="post-quote-thumb" :src="item.post.photo" alt="" loading="lazy">
                    <div class="post-quote-body">
                      <div class="post-quote-author">{{ item.post.author }}</div>
                      <div class="post-quote-text">{{ item.post.text }}</div>
                    </div>
                  </div>
                  <span class="align-middle message-text" v-html="formatMessageText(item.text)" @click="handleMessageClick"></span>
                    </div>
                  </template>
                </template>
                <div class="images position-relative" v-if="item.attachments?.length">
                  <div v-if="item.reactions?.length" class="msg-top-reactions">
                    <template v-for="(r, idx) in getTopReactions(item.reactions)" :key="r.emoji">
                      <span
                        class="msg-reaction-small"
                        :class="{ 'msg-reaction-mine': r.user_ids?.includes(currentUserId) }"
                        @click.stop="onReact(r.emoji, item)"
                      >{{ r.emoji }}<span v-if="r.count > 1" class="msg-reaction-count">{{ r.count }}</span></span>
                      <span v-if="idx === 1 && item.reactions.length > 2" class="msg-reaction-more" @click.stop="openContextMenu(item)">+{{ item.reactions.length - 2 }}</span>
                    </template>
                  </div>
                  <template v-for="(attachment, aidx) in item.attachments || []" :key="attachment.id || attachment.tempId || aidx">
                    <div
                      v-if="isImageAttachment(attachment)"
                      class="image position-relative"
                    >
                      <div class="position-relative" style="display: inline-block; overflow: hidden; border-radius: 4px; line-height: 0;">
                        <!-- Индикатор статуса загрузки -->
                        <transition name="upload-overlay">
                          <template v-if="attachment._pending || item._backgroundUploadStarted">
                            <div
                              class="upload-indicator position-absolute d-flex align-items-center justify-content-center"
                              style="top: 0; left: 0; right: 0; bottom: 0; z-index: 2; background: rgba(0,0,0,0.35); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);"
                            >
                              <div class="position-relative w-100 h-100">
                                <div
                                  class="position-absolute"
                                  style="left: 50%; top: 50%; transform: translate(-50%, -50%);"
                                >
                                  <div
                                    class="d-flex align-items-center justify-content-center mx-auto"
                                    :style="{ width: '44px', height: '44px', borderRadius: '50%', background: `conic-gradient(#ffffff ${getUploadProgress(attachment, item)}%, rgba(255,255,255,0.25) 0)` }"
                                  >
                                    <div
                                      class="d-flex align-items-center justify-content-center text-white"
                                      style="width: 34px; height: 34px; border-radius: 50%; background: rgba(0,0,0,0.55); font-size: 11px; font-weight: 600; line-height: 1;"
                                    >
                                      {{ getUploadProgress(attachment, item) }}%
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="position-absolute text-center text-white"
                                  style="left: 0; right: 0; bottom: 10px; font-size: 10px; line-height: 1;"
                                >
                                  {{ item.status === 'uploading' ? 'Загрузка...' : 'Отправка...' }}
                                </div>
                              </div>
                            </div>
                          </template>

                          <template v-else-if="item.status === 'error' || attachment._error">
                            <div
                              class="error-indicator position-absolute d-flex align-items-center justify-content-center"
                              style="top: 0; left: 0; right: 0; bottom: 0; z-index: 2; background: rgba(220,53,69,0.8); cursor: pointer;"
                              :title="t('messages.send_failed_retry')"
                              @click.stop="haptic(10); emit('retry', item)"
                            >
                              <div class="text-center text-white">
                                <i class="fa fa-exclamation-triangle mb-1"></i>
                                <div class="small" style="font-size: 10px; line-height: 1;">
                                  {{ t('messages.error') }}
                                </div>
                              </div>
                            </div>
                          </template>
                        </transition>

                        <!-- Изображение -->
                        <a
                          :href="attachment.url || attachment.thumbnail || attachment.preview_url"
                          class="d-block"
                          @click.stop="handleImageClick(attachment, $event, item)"
                        >
                          <img
                            :src="attachment.objectUrl || attachment.thumbnail || attachment.preview_url || attachment.url"
                            :alt="attachment.name"
                            class="d-block"
                            :class="{
                              'uploading': attachment._pending || item._backgroundUploadStarted,
                              'error': item.status === 'error' || attachment._error
                            }"
                            loading="lazy"
                            style="max-width: 200px; max-height: 200px; border-radius: 4px;"
                          />
                        </a>
                      </div>

                      <!-- Информация о файле -->
                      <div
                        v-if="false"
                        class="file-info small text-muted mt-1"
                        style="font-size: 11px; line-height: 1.2;"
                      >
                        <div class="text-truncate">{{ attachment.name }}</div>
                        <div v-if="attachment.size">{{ formatFileSize(attachment.size) }}</div>
                      </div>
                    </div>

                    <div
                      v-else-if="attachment?.name || attachment?.url"
                      class="file-attachment d-flex align-items-center p-2 border rounded"
                    >
                      <i class="fa fa-file-o mr-2"></i>
                      <div class="flex-grow-1">
                        <div class="small text-truncate">{{ attachment.name }}</div>
                        <div class="small text-muted" v-if="attachment.size">{{ formatFileSize(attachment.size) }}</div>
                      </div>
                    </div>
                  </template>
                </div>
                </div>

                <!-- Время и статус - внутри item-body как в AngularJS -->
                <div v-if="!item._deletedLocally" class="time-status-wrapper">
                  <small class="time text-gray">
                    {{ formatTime(item.timestamp || item.ts) }}
                  </small>

                  <!-- Статус доставки для отправленных сообщений -->
                  <small v-if="item.type === 'sent'" class="message-status-time mr-2"
                         :class="(item.is_read === true || item.is_read === 1 || item.status === 'read') ? 'text-primary' : 'text-gray'">
                    <!-- Pending (отправка) - анимированный спиннер -->
                    <i v-if="item.status === 'pending'" class="fa fa-spinner fa-spin" :title="t('messages.sending')"></i>

                    <!-- Read (две галочки синие) -->
                    <span v-else-if="item.is_read === true || item.is_read === 1 || item.status === 'read'"
                          class="message-status-read"
                          :title="item.read_at ? t('messages.read_at_time', { time: formatDateTime(item.read_at) }) : t('messages.read_status')">
                      <i class="fa fa-check"></i>
                      <i class="fa fa-check"></i>
                    </span>

                    <!-- Delivered (две галочки серые) -->
                    <span v-else-if="item.status === 'delivered'"
                          class="message-status-delivered"
                          :title="item.delivered_at ? t('messages.delivered_at_time', { time: formatDateTime(item.delivered_at) }) : t('messages.delivered_status')">
                      <i class="fa fa-check"></i>
                      <i class="fa fa-check"></i>
                    </span>

                    <!-- Failed/Error — кликабельный повтор отправки -->
                    <small v-else-if="item.status === 'failed' || item.status === 'error'"
                           class="message-status-time message-status-failed"
                           :title="t('messages.send_failed_retry')"
                           @click.stop="haptic(10); emit('retry', item)">
                      <i class="fa fa-exclamation-circle"></i>
                    </small>

                    <!-- Sent (одна галочка серая) -->
                    <i v-else-if="item.status === 'sent'"
                       class="fa fa-check"
                       :title="t('messages.sent_status')"></i>

                    <!-- Default (одна галочка) -->
                    <i v-else class="fa fa-check" :title="t('messages.sent_status')"></i>
                  </small>
                </div>
              </div>
            </div>
          </TransitionGroup>
        </div>
        <!-- anchor -->
        <div style="height: 1px;"></div>
      </div>
    </div>

    <transition name="ctx-menu-appear">
      <div
        v-if="ctxMenu.visible"
        class="msg-ctx-popup"
        :class="{ above: ctxMenu.above }"
        ref="popupRef"
        :style="ctxMenuStyle"
        @contextmenu.prevent
      >
          <!-- Emoji bar -->
          <div class="msg-ctx-emoji-bar" @wheel.prevent="onEmojiWheel">
            <button
              v-for="(emoji, ei) in quickEmojis"
              :key="emoji"
              class="msg-ctx-emoji"
              :style="{ animationDelay: (ei * 30) + 'ms' }"
              @click="onPopupReact(emoji)"
            ><AnimatedEmoji :emoji="emoji" :size="22" /></button>
          </div>
          <!-- Actions -->
          <div class="msg-ctx-menu">
            <button class="msg-ctx-action" @click="onReply">
              <i class="fe fe-corner-up-left"></i>
              <span>{{ t('messages.reply') }}</span>
            </button>
            <button
              v-if="ctxMenu.item?.type === 'sent' && !ctxMenu.item?._deletedLocally && (!ctxMenu.item?.attachments || ctxMenu.item.attachments.length === 0) && canEditMessage(ctxMenu.item)"
              class="msg-ctx-action"
              @click="onEdit"
            >
              <i class="fe fe-edit-2"></i>
              <span>{{ t('messages.edit') }}</span>
            </button>
            <button class="msg-ctx-action" @click="onCopy">
              <i class="fe fe-copy"></i>
              <span>{{ t('messages.copy') }}</span>
            </button>
            <div class="msg-ctx-divider"></div>
            <button class="msg-ctx-action msg-ctx-action-danger" @click="onDelete">
              <i class="fe fe-trash-2"></i>
              <span>{{ t('messages.delete_message') }}</span>
            </button>
          </div>
        </div>
      </transition>
    <!-- MessageGallery lightbox (no thumbnails, lightbox only) -->
    <MessageGallery
      v-if="currentGalleryAttachments.length > 0"
      ref="galleryRef"
      :attachments="currentGalleryAttachments"
      :show-thumbnails="false"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, reactive, nextTick, watch, onBeforeUnmount, onMounted } from 'vue';
import { useMessagesStore } from '@/stores/messages';
import { useI18n } from '@/composables/useI18n';
import { haptic } from '@/utils/haptics';
import { useMessageListOptimizations, useMessageGrouping } from '@/composables/useMessageCache';
import { useMessageScroll } from '@/composables/useMessageScroll';
import { useTouchGestures } from '@/composables/useTouchGestures';
import { logger } from '@/utils/logger';
import AnimatedEmoji from './AnimatedEmoji.vue';
import MessageGallery from './MessageGallery.vue';

// Глобальные типы для совместимости с AngularJS
declare global {
  interface Window {
    TimezoneHelper?: {
      formatRelativeTime: (timestamp: number) => string;
      formatTime: (timestamp: number, locale: string) => string;
      getDisplayDate: (date: Date) => string;
      getCurrentLocale: () => string;
      groupMessagesByLocalDate: (messages: any[], locale: string) => any;
    };
    messenger?: {
      error: (message: string) => void;
      success: (message: string) => void;
      info?: (message: string) => void;
    };
    websocket?: WebSocket;
  }
}

const { t } = useI18n();
const store = useMessagesStore();

const emit = defineEmits<{
  (e: 'restore', item: any): void;
  (e: 'reply', item: any): void;
  (e: 'edit', item: any): void;
  (e: 'deleteMessage', item: any): void;
  (e: 'react', item: any, emoji: string): void;
  (e: 'toggleSelect', item: any): void;
  (e: 'retry', item: any): void;
}>();

const props = defineProps<{
  messages: any[];
  contactId?: string | number;
  selectionMode?: boolean;
  selectedIds?: Set<any>;
}>();

// Оптимизированные утилиты из composable (после объявления props)
const {
  parseGiftMessage,
  isImageAttachment,
  getTopReactions,
  getTypeClass,
  getUploadProgress,
  formatFileSize,
  formatTime,
  formatDateTime
} = useMessageListOptimizations(props);

// Оптимизированная группировка сообщений (shallowRef для производительности)
const messagesRef = computed(() => props.messages);
const { grouped } = useMessageGrouping(messagesRef);

const currentUserId = computed(() => {
  return (window as any).__messagesCurrentUserId || (window as any).currentUser?.id || null;
});

// Highlighted message (for scroll-to-quote highlight)
const highlightedId = ref<string | number | null>(null);
let highlightTimer: ReturnType<typeof setTimeout> | null = null;

// --- Touch gestures with state machine ---
let recentTouch = false; // true after touch event, prevents synthetic click
let recentTouchTimer: ReturnType<typeof setTimeout> | null = null;

const gestures = useTouchGestures({
  onDoubleTap: (item) => {
    onReact('❤️', item);
  },
  onSingleTap: (item, touchType) => {
    // Toggle: close popup if already open on this message
    if (ctxMenu.visible && String(ctxMenu.item?.id) === String(item.id)) {
      closeContextMenu();
      return;
    }
    if (touchType === 'image') {
      const attachment = item.attachments?.[0];
      if (attachment) handleImageClick(attachment, undefined, item);
    } else if (props.selectionMode) {
      emit('toggleSelect', item);
    } else {
      openContextMenu(item);
    }
  },
  onLongPress: (item) => {
    if (navigator.vibrate) navigator.vibrate(props.selectionMode ? 20 : [40, 30, 40]);
    emit('toggleSelect', item);
  }
});

// --- Context menu (inline, like linda theme) ---
const quickEmojis = ['❤️', '😂', '👍', '😮', '😢', '🔥'];

const ctxMenu = reactive({ visible: false, x: 0, y: 0, item: null as any, above: false, side: 'left' as 'left' | 'right' });

// Consistent edge margin for popup
const CTX_EDGE_MARGIN = 16;

// Computed style for the popup — fixed to escape overflow:hidden on .conversation-items
const ctxMenuStyle = computed(() => {
  const base: Record<string, string | number> = {
    position: 'absolute',
    top: ctxMenu.y + 'px',
    zIndex: 1042,
  };
  if (ctxMenu.side === 'right') {
    base.right = ctxMenu.x + 'px';
  } else {
    base.left = ctxMenu.x + 'px';
  }
  return base;
});

// Find the .item DOM element for a given message
const findMsgElement = (item: any): HTMLElement | null => {
  if (!containerRef.value || !item?.id) {
    logger.log('[ctxMenu] findMsgElement: no container or id', { id: item?.id, hasContainer: !!containerRef.value });
    return null;
  }
  const el = containerRef.value.querySelector(`[data-msg-id="${item.id}"]`) as HTMLElement | null;
  logger.log('[ctxMenu] findMsgElement:', { id: item.id, found: !!el });
  return el;
};

const openContextMenu = (item: any, _e?: MouseEvent | Touch) => {
  if (!item || item._deletedLocally) return;
  haptic(15);

  // Фокус с поля ввода уже снят в onMsgTouchEnd (сразу по touchend валидного
  // тапа, до задержки single-tap) — клавиатура не успевает мигнуть.
  // Desktop-путь меню фокус не трогает.

  const menuContainer = menuContainerRef.value;
  if (!menuContainer) return;

  const container = containerRef.value;
  if (!container) return;

  const menuContainerRect = menuContainer.getBoundingClientRect();
  const msgEl = findMsgElement(item);
  if (!msgEl) return;

  // Якоримся к видимому пузырю (.item-content), а не ко всей строке .item —
  // аватар и тайм-статус могут выступать ниже баббла и завышать отступ.
  const anchorEl = (msgEl.querySelector('.item-content') as HTMLElement | null) ?? msgEl;
  const msgRect = anchorEl.getBoundingClientRect();

  const popupH = 200; // оценка только для выбора направления; точная высота — после рендера
  const gap = 12;

  const toMenuContainerY = (vy: number) => vy - menuContainerRect.top + menuContainer.scrollTop;

  const spaceBelow = menuContainerRect.bottom - msgRect.bottom;
  const spaceAbove = msgRect.top - menuContainerRect.top;
  const placeAbove = spaceBelow < popupH + gap && spaceAbove > spaceBelow;

  let y: number;
  if (placeAbove) {
    y = toMenuContainerY(msgRect.top) - popupH - gap;
  } else {
    y = toMenuContainerY(msgRect.bottom) + gap;
  }

  if (y < menuContainer.scrollTop + 8) y = menuContainer.scrollTop + 8;

  const isSent = item.type === 'sent';
  let x: number;
  let side: 'left' | 'right';

  if (isSent) {
    const rightOffset = menuContainerRect.right - msgRect.right;
    x = Math.max(CTX_EDGE_MARGIN, rightOffset);
    side = 'right';
  } else {
    const leftOffset = msgRect.left - menuContainerRect.left;
    x = Math.max(CTX_EDGE_MARGIN, leftOffset);
    side = 'left';
  }

  ctxMenu.item = item;
  ctxMenu.x = x;
  ctxMenu.y = y;
  ctxMenu.above = placeAbove;
  ctxMenu.side = side;
  ctxMenu.visible = true;

  // После рендера уточняем позицию по реальной высоте попапа — иначе при
  // открытии над сообщением меню висит с большим зазором (оценка завышена).
  nextTick(() => {
    const el = popupRef.value;
    if (!el || !ctxMenu.visible || !ctxMenu.above) return;
    ctxMenu.y = Math.max(
      toMenuContainerY(msgRect.top) - el.offsetHeight - gap,
      menuContainer.scrollTop + 8
    );
  });

  logger.log('[ctxMenu] open', { id: item.id, type: item.type, x, y, placeAbove, side });
};

const closeContextMenu = () => {
  ctxMenu.visible = false;
  ctxMenu.item = null;
};

// Close menu when any other modal/overlay appears in the DOM
const _onGlobalKeydown = (e: KeyboardEvent) => {
  if (e.key === 'Escape' && ctxMenu.visible) closeContextMenu();
};

// Watch for any other modal appearing — close our menu
const _observer = typeof MutationObserver !== 'undefined' ? new MutationObserver((mutations) => {
  if (!ctxMenu.visible) return;
  // Only react if a NEW modal/overlay was actually added to the DOM in this mutation batch
  for (const m of mutations) {
    for (const node of Array.from(m.addedNodes)) {
      if (node instanceof Element) {
        if (
          node.matches?.('.modal, .swal2-container') ||
          node.querySelector?.('.modal, .swal2-container')
        ) {
          closeContextMenu();
          return;
        }
      }
    }
  }
}) : null;

const _onScrollClose = () => closeContextMenu();

watch(() => ctxMenu.visible, (visible) => {
  if (visible) {
    document.addEventListener('keydown', _onGlobalKeydown, true);
    _observer?.observe(document.body, { childList: true, subtree: true });
    containerRef.value?.addEventListener('scroll', _onScrollClose, { passive: true });
  } else {
    document.removeEventListener('keydown', _onGlobalKeydown, true);
    _observer?.disconnect();
    containerRef.value?.removeEventListener('scroll', _onScrollClose);
  }
});

// Popup action handlers
const onReply = () => {
  if (ctxMenu.item) emit('reply', ctxMenu.item);
  closeContextMenu();
};

const onEdit = () => {
  if (ctxMenu.item) emit('edit', ctxMenu.item);
  closeContextMenu();
};

const onCopy = () => {
  const item = ctxMenu.item;
  if (item?.text) {
    const text = item.text.replace(new RegExp('\\[gift\].*?\\[/gift\]', 'g'), '').trim();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).catch(() => {});
    } else {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
  }
};

const onDelete = () => {
  if (ctxMenu.item) emit('deleteMessage', ctxMenu.item);
  closeContextMenu();
};

const onPopupReact = (emoji: string) => {
  if (ctxMenu.item) emit('react', ctxMenu.item, emoji);
  closeContextMenu();
};

const onEmojiWheel = (e: WheelEvent) => {
  const bar = e.currentTarget as HTMLElement;
  if (bar) bar.scrollLeft += e.deltaY as number;
};

// ─── Desktop events (suppressed on touch devices) ───

// Left click on message: select/deselect (desktop only)
const onMsgLeftClick = (item: any, e: MouseEvent) => {
  // Skip synthetic clicks from touch — mobile handles its own logic
  if (recentTouch) return;
  if (item._deletedLocally) return;
  if (ctxMenu.visible) {
    closeContextMenu();
    return;
  }

  // Проверяем клик по цитате - не открываем модальное окно
  const target = e.target as HTMLElement;
  const clickableQuote = target.closest('.clickable-quote');
  if (clickableQuote) {
    // Кликом по цитате занимается handleMessageClick
    return;
  }

  // Проверяем что клик был в рамках .item контейнера
  const itemElement = target.closest('.item');
  if (!itemElement) return;

  emit('toggleSelect', item);

  // Предотвращаем всплытие чтобы избежать двойных событий
  e.stopPropagation();
};

// Right click on message: show context menu (desktop only)
const onMsgRightClick = (item: any, e: MouseEvent) => {
  if (recentTouch) return;
  if (item._deletedLocally) return;
  if (ctxMenu.visible && String(ctxMenu.item?.id) === String(item.id)) {
    closeContextMenu();
    return;
  }

  // Проверяем клик по цитате - не открываем контекстное меню
  const target = e.target as HTMLElement;
  const clickableQuote = target.closest('.clickable-quote');
  if (clickableQuote) {
    // Кликом по цитате занимается handleMessageClick
    e.preventDefault();
    return;
  }

  // Проверяем что клик был именно по контенту сообщения, а не по пустому пространству
  const contentElement = target.closest('.item-body, .gift-message-card, .text, .images');
  if (!contentElement) return;

  openContextMenu(item, e);

  // Предотвращаем всплытие чтобы избежать двойных событий
  e.stopPropagation();
};

// ─── Mobile touch events with state machine ───
// Simplified logic using useTouchGestures composable:
// - Double tap on content → ❤️ reaction
// - Single tap on image → open image
// - Single tap on content → context menu (or select in selection mode)
// - Long press → vibration + select message

// Mark that touch just happened — suppresses synthetic click/dblclick
const markRecentTouch = () => {
  recentTouch = true;
  if (recentTouchTimer) clearTimeout(recentTouchTimer);
  recentTouchTimer = setTimeout(() => { recentTouch = false; }, 500);
};

// Определяет тип касания: фото или область вокруг фото/текст
const getTouchTargetType = (target: HTMLElement): 'image' | 'content' => {
  // Касание по самому изображению
  if (target.closest('img')) {
    return 'image';
  }
  // Касание по текстовому контенту или области вокруг фото
  if (target.closest('.text, .gift-message-card, .image, .images')) {
    return 'content';
  }
  return 'content'; // По умолчанию считаем контентом
};

// Стартовая точка касания на цитате — для отсечения свайпов от тапов
let quoteTouchStart: { x: number; y: number } | null = null;

const onMsgTouchStart = (item: any, e: TouchEvent) => {
  markRecentTouch();
  
  if (item._deletedLocally) return;
  
  const target = e.target as HTMLElement;
  const clickableQuote = target.closest('.clickable-quote');
  if (clickableQuote) {
    gestures.cancel();
    // Запоминаем точку старта: отличаем тап по цитате от свайпа,
    // начатого на цитате (иначе скролл триггерил автопрокрутку к оригиналу)
    const t = e.touches[0];
    quoteTouchStart = t ? { x: t.clientX, y: t.clientY } : null;
    return;
  }
  
  quoteTouchStart = null;
  const touchType = getTouchTargetType(target);
  gestures.handleStart(item, e, touchType);
};

const onMsgTouchMove = (e: TouchEvent) => {
  gestures.handleMove(e);
};

const onMsgTouchEnd = (item: any, e: TouchEvent) => {
  markRecentTouch();
  e.preventDefault(); // Suppress synthetic click after touch
  
  if (item._deletedLocally) {
    gestures.cancel();
    return;
  }
  
  const target = e.target as HTMLElement;
  const clickableQuote = target.closest('.clickable-quote');
  if (clickableQuote) {
    gestures.cancel();
    e.preventDefault();
    // Скролл, начатый на цитате: палец сместился — это не тап,
    // автопрокрутку к оригиналу не запускаем
    const start = quoteTouchStart;
    quoteTouchStart = null;
    const t = e.changedTouches[0];
    const moved = start && t
      ? Math.hypot(t.clientX - start.x, t.clientY - start.y)
      : 0;
    if (moved > 10) return;
    const replyId = clickableQuote.getAttribute('data-reply-id');
    if (replyId) {
      scrollToMessage(replyId);
    } else {
      if (window.messenger && window.messenger.error) {
        window.messenger.error('Переход к оригинальному сообщению недоступен для старых цитат');
      } else {
        logger.log('Переход к оригинальному сообщению недоступен для старых цитат');
      }
    }
    return;
  }
  
  quoteTouchStart = null;
  e.preventDefault();

  // Снимаем фокус с поля ввода сразу по touchend валидного тапа —
  // до ~280мс задержки распознавания single-tap в gestures.handleEnd.
  // Поздний blur (в openContextMenu) давал клавиатуре время мигнуть:
  // при скрытой, но сфокусированной textarea тап успевал её переоткрыть.
  // state==='tap_start' значит тап реален: скролл (move>10px) и long-press
  // уже сбросили состояние в idle и фокус не трогаем.
  if (gestures.state.value === 'tap_start') {
    (document.activeElement as HTMLElement | null)?.blur();
  }

  // In selection mode, toggle immediately — no need to wait for double-tap
  if (props.selectionMode) {
    // Skip if long press already fired (state changed to idle after reset)
    if (gestures.state.value !== 'tap_start') {
      gestures.cancel();
      return;
    }
    gestures.cancel();
    if (navigator.vibrate) navigator.vibrate(15);
    emit('toggleSelect', item);
    return;
  }
  
  gestures.handleEnd(item);
};

// Wheel event handler for performance optimization
const onWheel = (_e: WheelEvent) => {
  // Let the default scroll behavior happen
  // This handler exists to make the wheel event passive
};

// Check if message can be edited (within 15 minutes of sending, like WhatsApp/Instagram).
//
// Раньше эта функция безусловно блокировала все сообщения с id `temp-...`.
// Но после успешной отправки через HTTP `id` в store остаётся tempId, а серверный ID
// сохраняется в `_serverId` (см. stores/messages/actions.ts → sendMessage success-path).
// Замена `id` на серверный происходит только позже, когда WebSocket-merge или reload
// сольёт optimistic и server-подтверждённое сообщение. До этого момента (секунды—минуты)
// пользователь физически не мог редактировать только что отправленное сообщение —
// кнопка Edit была скрыта из-за этой проверки.
//
// Теперь разрешаем редактирование, если сервер подтвердил отправку (_serverId установлен).
// API-вызов в saveEdit отправляет _serverId ?? id, поэтому сервер находит сообщение.
const canEditMessage = (item: any): boolean => {
  if (!item || item.type !== 'sent') return false;

  const idStr = item.id != null ? String(item.id) : '';
  const isTemp = idStr.startsWith('temp-') || idStr.startsWith('temp_');
  const hasServerId = item._serverId !== undefined && item._serverId !== null;

  // Сообщение ещё не подтверждено сервером — редактировать нечего.
  if (isTemp && !hasServerId) return false;

  // Нельзя редактировать failed-сообщения (нужно сначала retry).
  if (item.status === 'failed') return false;

  // Нельзя редактировать прочитанные сообщения — anti-scam / anti-gaslighting.
  // Dating-специфика: в отличие от WhatsApp/Telegram все крупные dating-сервисы
  // (Tinder/Bumble/Hinge) вообще не разрешают edit. Мы как компромисс разрешаем
  // только до прочтения + в пределах 15-минутного окна. См. также backend-проверку
  // в MessagesController::actionEditMessage (error_code: edit_read_forbidden).
  if (item.status === 'read' || item.is_read === true || item.is_read === 1) {
    return false;
  }

  // Проверка времени с момента отправки (15 минут = 900 секунд).
  const EDIT_TIME_LIMIT_SECONDS = 15 * 60;
  const messageTimestamp = item.timestamp || item.ts || item.created_at;

  if (messageTimestamp) {
    const now = Math.floor(Date.now() / 1000);
    const timeSinceCreated = now - messageTimestamp;

    if (timeSinceCreated > EDIT_TIME_LIMIT_SECONDS) {
      return false;
    }
  }

  return true;
};

const onReact = (emoji: string, item?: any) => {
  haptic(8);
  const target = item || null;
  if (target) emit('react', target, emoji);
};

watch(() => props.contactId, () => {
  closeContextMenu();
  gestures.cancel();
});

defineExpose({
  closeContextMenu
});

onBeforeUnmount(() => {
  gestures.cancel();
  if (recentTouchTimer) clearTimeout(recentTouchTimer);
  document.removeEventListener('keydown', _onGlobalKeydown, true);
  containerRef.value?.removeEventListener('scroll', _onScrollClose);
  _observer?.disconnect();
});

const menuContainerRef = ref<HTMLElement | null>(null);
const containerRef = ref<HTMLElement | null>(null);
const itemsRef = ref<HTMLElement | null>(null);
const popupRef = ref<HTMLElement | null>(null);

const showNewMessagesIndicator = ref(false);
const unreadMessagesCount = ref(0);
const isContactChanging = ref(false);

// Маркер последнего сообщения в конце списка: рост длины массива без смены
// последнего сообщения — это prepend истории / merge-синхронизация, а не новые
// сообщения — их не учитываем в индикаторе
let prevTailId: string | null = null;
const syncTailId = (): void => {
  const last = props.messages[props.messages.length - 1];
  prevTailId = last ? String(last.id ?? '') : null;
};

watch(() => props.contactId, async (newId, oldId) => {
  showNewMessagesIndicator.value = false;
  unreadMessagesCount.value = 0;
  prevTailId = null;

  if (!newId || newId === oldId) return;

  isContactChanging.value = true;
  await nextTick();
  // Синхронный скролл до paint — пользователь сразу видит последние сообщения
  const el = containerRef.value;
  if (el && props.messages.length > 0) {
    el.scrollTop = el.scrollHeight;
  }
  // Стабильный скролл для дозагрузки изображений
  await scrollToBottomStable({
    force: true,
    behavior: 'auto',
    waitForImages: true,
    imageTimeout: 1500,
    maxAttempts: 5,
  });
  setTimeout(() => {
    isContactChanging.value = false;
  }, 1000);
});

const scrollToNewMessages = async () => {
  showNewMessagesIndicator.value = false;
  unreadMessagesCount.value = 0;
  await nextTick();
  await scrollToBottom({ force: true, behavior: 'smooth' });
  
  if (props.contactId) {
    store.readConversation(props.contactId);
  }
};

const galleryRef = ref<{ openGallery: (index: number) => void } | null>(null);
const currentGalleryAttachments = ref<any[]>([]);
const pendingGalleryIndex = ref<number | null>(null);

const getConversationImageAttachments = () => {
  const all: any[] = [];
  props.messages.forEach((message: any) => {
    message.attachments?.forEach((attachment: any) => {
      if (isImageAttachment(attachment)) {
        all.push(attachment);
      }
    });
  });
  return all;
};

const openGalleryWithAttachments = (attachments: any[], index: number) => {
  currentGalleryAttachments.value = attachments;
  pendingGalleryIndex.value = index;
  nextTick(() => {
    if (galleryRef.value && pendingGalleryIndex.value !== null) {
      galleryRef.value.openGallery(pendingGalleryIndex.value);
      pendingGalleryIndex.value = null;
    }
  });
};

watch(galleryRef, (newRef) => {
  if (newRef && pendingGalleryIndex.value !== null) {
    newRef.openGallery(pendingGalleryIndex.value);
    pendingGalleryIndex.value = null;
  }
});

const { scrollToBottom, scrollToBottomStable, isAtBottom, setupBottomObserver, cleanupBottomObserver } = useMessageScroll(containerRef);

watch(
  () => props.messages.length,
  async (newCount, oldCount) => {
    if (!oldCount && newCount > 0) {
      // Первая загрузка сообщений — мгновенный скролл до paint
      await nextTick();
      const el = containerRef.value;
      if (el) {
        el.scrollTop = el.scrollHeight;
      }
      syncTailId();
      return;
    }
    if (!oldCount || newCount <= oldCount) {
      syncTailId();
      await nextTick();
      return;
    }

    if (isContactChanging.value) {
      syncTailId();
      await nextTick();
      return;
    }

    await nextTick();
    await new Promise(resolve => setTimeout(resolve, 300));

    const lastMessage = props.messages[props.messages.length - 1];
    // Рост длины без нового сообщения в конце — prepend истории / merge-синхронизация,
    // а не новые сообщения: не раздуваем индикатор
    const tailId = lastMessage ? String(lastMessage.id ?? '') : null;
    if (tailId !== null && tailId === prevTailId) {
      return;
    }
    prevTailId = tailId;
    const isIncoming = lastMessage?.type === 'received' || lastMessage?.type === 'inbox';
    const isSent = lastMessage?.type === 'sent';

    if (isSent) {
      const hasMedia = lastMessage?.attachments?.length > 0 || lastMessage?.hasMedia;
      await scrollToBottomStable({
        force: true,
        behavior: 'auto',
        waitForImages: hasMedia,
        imageTimeout: 2000,
        maxAttempts: 5
      });
    } else if (isIncoming) {
      const container = containerRef.value;
      if (!container) return;

      const distanceToBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
      const isActuallyAtBottom = distanceToBottom <= 100;

      if (isActuallyAtBottom) {
        await scrollToBottom({ behavior: 'smooth' });
        if (props.contactId) {
          store.readConversation(props.contactId);
        }
      } else {
        unreadMessagesCount.value += (newCount - oldCount);
        showNewMessagesIndicator.value = true;
      }
    }
  }
);

// Reset indicator + auto-read when user scrolls to bottom manually.
// We use a direct scroll listener instead of IntersectionObserver because
// the observer's anchor (position:absolute; bottom:0) stays at the viewport
// bottom of the scroll container, making isAtBottom always true.
let _indicatorScrollHandler: (() => void) | null = null;

const setupIndicatorScrollHandler = (): void => {
  const el = containerRef.value;
  if (!el || _indicatorScrollHandler) return;

  let wasNearBottom = true;
  _indicatorScrollHandler = () => {
    const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
    const nearBottom = distance <= 100;

    if (nearBottom && !wasNearBottom) {
      if (showNewMessagesIndicator.value) {
        showNewMessagesIndicator.value = false;
        unreadMessagesCount.value = 0;
      }
      if (props.contactId) {
        store.readConversation(props.contactId);
      }
    }
    wasNearBottom = nearBottom;
  };

  el.addEventListener('scroll', _indicatorScrollHandler, { passive: true });
};

onMounted(() => {
  setupIndicatorScrollHandler();
});

onBeforeUnmount(() => {
  if (_indicatorScrollHandler && containerRef.value) {
    containerRef.value.removeEventListener('scroll', _indicatorScrollHandler);
    _indicatorScrollHandler = null;
  }
});

// Реагируем на запрос скролла от стора (для явных запросов).
// Используется, например, при загрузке сообщений через handleSelectContact
// (MessagesApp.vue:716) или после отправки/получения медиа.
// scrollToBottomStable устойчив к изменениям layout (RAF-проверка высоты),
// что критично при mount'е со множеством сообщений/изображений.
watch(
  () => store.scrollRequest,
  async () => {
    await nextTick();
    await scrollToBottomStable({
      force: true,
      behavior: 'auto',
      waitForImages: true,
      imageTimeout: 1500,
      maxAttempts: 5,
    });
  }
);

// Скроллим вниз при монтировании.
// Раньше здесь был каскад из 6 setTimeout(100ms) с force:true — это блокировало
// ручной скролл пользователя первые ~600ms после открытия диалога и утекало
// при размонтировании. Теперь используем scrollToBottomStable, который
// через requestAnimationFrame проверяет стабилизацию layout и скроллит
// до тех пор, пока scrollHeight не перестанет меняться (до maxAttempts).
let mountScrollTimer: number | null = null;
onMounted(() => {
  // Настраиваем IntersectionObserver для более точного отслеживания дна
  setupBottomObserver();

  // Синхронный скролл если сообщения уже есть — до paint браузера
  const el = containerRef.value;
  if (el && props.messages.length > 0) {
    el.scrollTop = el.scrollHeight;
  }

  // Отложенный стабильный скролл для дозагрузки изображений
  mountScrollTimer = window.setTimeout(() => {
    mountScrollTimer = null;
    void scrollToBottomStable({
      force: true,
      behavior: 'auto',
      waitForImages: true,
      imageTimeout: 1500,
      maxAttempts: 5,
    });
  }, 50);
});

// Очистка при размонтировании
onBeforeUnmount(() => {
  if (mountScrollTimer !== null) {
    clearTimeout(mountScrollTimer);
    mountScrollTimer = null;
  }
  if (recentTouchTimer) clearTimeout(recentTouchTimer);
  cleanupBottomObserver(); // Очищаем IntersectionObserver
});

const getItemClasses = (item: any) => {
  return {
    'selected': props.selectedIds?.has(String(item?.id)),
    'selection-mode': props.selectionMode,
    'highlighted-message': highlightedId.value !== null && String(highlightedId.value) === String(item?.id),
  };
};

const getAvatarStyle = (item: any) => {
  const explicit = item?.user?.avatar;
  if (explicit) {
    return { backgroundImage: `url(${explicit})` };
  }

  const currentUserAvatar = (window as any).__messagesCurrentUserAvatar || (window as any).currentUser?.avatar || (window as any).currentUser?.photo || null;
  const chatId = item?.chatId ?? item?.contactId;
  const contactAvatar = chatId !== undefined && chatId !== null
    ? (store.conversations?.[String(chatId)]?.contact?.avatar || (store.conversations as any)?.[chatId]?.contact?.avatar || null)
    : null;
  const fallback = item?.type === 'sent' ? currentUserAvatar : contactAvatar;
  return fallback ? { backgroundImage: `url(${fallback})` } : { backgroundImage: 'none' };
};

// Логирование статусов для диагностики
watch(() => props.messages, (newMessages) => {
  if (newMessages && newMessages.length > 0) {
    const sentMessages = newMessages.filter(m => m.type === 'sent');
    if (sentMessages.length > 0) {
      logger.log('MessageList: Sent messages statuses:', sentMessages.map(m => ({
        id: m.id,
        status: m.status,
        is_read: m.is_read,
      })));
    }
  }
}, { immediate: true });

// Module-level regex constants (compiled once, reused across renders)
const GIFT_PREFIX_REGEX = new RegExp('^\\[gift].*?\\[/gift]');
const REPLY_ID_REGEX = new RegExp('^\\[reply:(\\d+)](.*)$');

// Функции для шаблона (не дублируются из composable)
const getAngularTypeClass = (item: any) => getTypeClass(item?.type);

const formatMessageText = (text: string | undefined): string => {
  if (!text) return '';

  // Strip [gift]...[/gift] prefix if present
  let cleaned = text.replace(GIFT_PREFIX_REGEX, '');

  const lines = cleaned.split('\n');
  const htmlLines: string[] = [];
  let inQuote = false;

  for (const line of lines) {
    if (line.startsWith('> ') || line === '>') {
      let quoteText = line.startsWith('> ') ? line.substring(2) : line.substring(1);
      const replyIdMatch = quoteText.match(REPLY_ID_REGEX);
      let processedQuoteText = quoteText;
      let replyId = null;

      if (replyIdMatch) {
        replyId = replyIdMatch[1];
        processedQuoteText = replyIdMatch[2];
      }
      
      processedQuoteText = processedQuoteText
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
      
      if (!inQuote) {
        // Медиа-цитата: если оригинал (по reply-ID) содержит вложения,
        // показываем в цитате чип с иконкой фото перед текстом
        let quoteInner = processedQuoteText;
        if (replyId) {
          const orig = props.messages.find((m: any) =>
            String(m.id) === String(replyId) || String(m._serverId) === String(replyId)
          );
          if (orig?.attachments?.length) {
            // Миниатюра оригинала в цитате (как в Telegram/WhatsApp);
            // подпись «Фото» — только если thumbnail недоступен (иконка-фолбэк)
            const att = (orig.attachments as any[]).find((a) => a?.thumbnail || a?.url || a?.preview_url) || orig.attachments[0];
            const thumb = String(att?.thumbnail || att?.url || att?.preview_url || '').replace(/"/g, '%22');
            const mediaIcon = thumb
              ? `<img class="msg-quote-thumb" src="${thumb}" alt="" loading="lazy">`
              : `<i class="fe fe-image" aria-hidden="true"></i><span>${t('messages.photo')}</span>`;
            const label = quoteInner ? ` ${quoteInner}` : '';
            quoteInner = `<span class="media-quote">${mediaIcon}</span>${label}`;
          }
        }
        htmlLines.push(`<div class="msg-quote clickable-quote"${replyId ? ` data-reply-id="${replyId}"` : ''}>${quoteInner}`);
        inQuote = true;
      } else {
        htmlLines.push(processedQuoteText);
      }
    } else {
      if (inQuote) {
        htmlLines.push('</div>');
        inQuote = false;
      }
      
      const escaped = line
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
      
      htmlLines.push(escaped);
    }
  }
  if (inQuote) htmlLines.push('</div>');
  
  return htmlLines.join('<span style="display: block; margin-bottom: 2px;"></span>');
};

const handleMessageClick = (event: MouseEvent) => {
  const target = event.target as HTMLElement;
  const clickableQuote = target.closest('.clickable-quote');
  
  if (clickableQuote) {
    event.stopPropagation();
    event.preventDefault();
    
    const replyId = clickableQuote.getAttribute('data-reply-id');
    
    if (replyId) {
      scrollToMessage(replyId);
    } else {
      window.messenger?.error('Переход к оригинальному сообщению недоступен для старых цитат');
    }
  }
};

const scrollToMessage = (messageId: string) => {
  const messageElement = document.querySelector(`[data-msg-id="${messageId}"]`);
  
  if (messageElement) {
    messageElement.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'center' 
    });
    
    if (highlightTimer) clearTimeout(highlightTimer);
    highlightedId.value = String(messageId);
    highlightTimer = setTimeout(() => {
      highlightedId.value = null;
    }, 2000);
  }
};

const handleImageClick = (attachment: any, event?: Event, item?: any) => {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  closeContextMenu();

  logger.log('Image clicked:', attachment);

  // Open gallery with all image attachments across the conversation
  const allAttachments = getConversationImageAttachments();
  const index = allAttachments.findIndex((a: any) => a.id === attachment.id || a.url === attachment.url);

  if (allAttachments.length > 0) {
    openGalleryWithAttachments(allAttachments, Math.max(0, index));
  } else if (attachment.url) {
    // Fallback for single attachment without conversation context
    openGalleryWithAttachments([attachment], 0);
  }
};
</script>

<style scoped>
/* Component specific styles */

/* New messages indicator - positioned at right */
.new-messages-indicator {
  position: absolute;
  bottom: 80px;
  right: 20px;
  left: auto;
  transform: none;
  z-index: 100;
  background: #007bff;
  color: white;
  padding: 10px 18px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.new-messages-indicator:hover {
  background: #0056b3;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.5);
}

.new-messages-indicator:active {
  transform: translateY(0);
}

.upload-overlay-enter-active,
.upload-overlay-leave-active {
  transition: opacity 200ms ease;
}

.upload-overlay-leave-active {
  transition-delay: 150ms;
}

.upload-overlay-enter-from,
.upload-overlay-leave-to {
  opacity: 0;
}

.item {
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  cursor: pointer;
}

.item.selected {
  background-color: rgba(70, 127, 207, 0.12);
}

.item.selection-mode {
  cursor: pointer;
}

/* Контейнер для времени, статуса и реакций */
.time-status-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  margin-top: 2px;
}

.item.sent .time-status-wrapper {
  align-items: flex-end;
}

/* Top reactions on message */
.msg-top-reactions {
  position: absolute;
  top: -10px;
  display: flex;
  align-items: center;
  gap: 2px;
  z-index: 1;
}

.item.inbox .msg-top-reactions {
  right: -10px;
}

.item.sent .msg-top-reactions {
  left: -10px;
}

@keyframes reaction-pop {
  0%   { transform: scale(0); opacity: 0; }
  60%  { transform: scale(1.2); }
  100% { transform: scale(1); opacity: 1; }
}

.msg-reaction-small {
  display: inline-flex;
  align-items: center;
  gap: 1px;
  background: var(--msg-reaction-bg, #fffffff2);
  color: var(--msg-reaction-color, inherit);
  border-radius: 10px;
  padding: 2px 4px;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  transition: all 0.15s;
  box-shadow: var(--msg-reaction-shadow, 0 1px 3px #0000001a);
  font-family: 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  animation: reaction-pop 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.msg-reaction-small:hover {
  transform: scale(1.1);
  background: var(--msg-reaction-hover-bg, var(--msg-reaction-bg, #fffffff2));
  box-shadow: var(--msg-reaction-hover-shadow, 0 2px 6px rgba(0, 0, 0, 0.15));
}

.msg-reaction-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  border-radius: 10px;
  padding: 1px 4px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  min-width: 16px;
}

.msg-reaction-more:hover {
  background: rgba(0, 0, 0, 0.85);
  transform: scale(1.1);
}

.msg-reaction-count {
  font-size: 10px;
  color: inherit;
  font-weight: 600;
  opacity: 0.8;
}

.msg-reaction-small .msg-reaction-count {
  color: var(--msg-reaction-count-color, #333);
}

/* Legacy reactions row (kept for backward compatibility) */
.msg-reactions-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  margin-bottom: 2px;
}

.msg-reaction-badge {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  padding: 1px 6px;
  font-size: 14px;
  line-height: 1.4;
  cursor: pointer;
  transition: background 0.15s;
}

.msg-reaction-badge:hover {
  background: rgba(0, 0, 0, 0.1);
}

.time {
  font-size: 0.75rem;
  color: #6c757d;
  white-space: nowrap;
  line-height: 1.2;
}


/* Стили для времени статусов сообщений */
.message-status-time {
  font-size: 0.75rem;
  color: #6c757d;
  white-space: nowrap;
}

/* Статус "Доставлено" - две серые галочки */
.message-status-delivered {
  color: #6c757d;
  display: inline-flex;
  align-items: center;
  position: relative;
}

.message-status-delivered i:first-child {
  position: relative;
  z-index: 1;
}

.message-status-delivered i:last-child {
  position: relative;
  margin-left: -0.3rem;
  z-index: 2;
}

/* Статус "Прочитано" - две синие галочки */
.message-status-read {
  color: #007bff;
  display: inline-flex;
  align-items: center;
  position: relative;
}

.message-status-read i:first-child {
  position: relative;
  z-index: 1;
}

.message-status-read i:last-child {
  position: relative;
  margin-left: -0.3rem;
  z-index: 2;
}

/* Анимация появления галочек */
.message-status i {
  animation: checkmark-appear 0.3s ease-in-out;
}

@keyframes checkmark-appear {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}


.item.received .time {
  margin-left: 0.5rem;
  margin-right: 0;
}

.item.sent .time {
  margin-left: 0;
  margin-right: 0.5rem;
}

.date {
  text-align: center;
  margin: 20px 0;
  position: relative;
}



@keyframes message-pop-in {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.8);
  }
  50% {
    opacity: 1;
    transform: translateY(-2px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Gift message card */
.gift-message-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: 200px;
  text-align: center;
}

.gift-message-image {
  padding: 12px 12px 4px;
}

.gift-message-image img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.gift-message-info {
  padding: 4px 12px 10px;
}

.gift-message-title {
  font-weight: 600;
  font-size: 13px;
  color: #333;
}

/* Fix emoji rendering in messages */
.message-text {
  font-family: 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.gift-message-text {
  margin-top: 2px;
  font-size: 12px;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  /* Улучшение touch событий для мобильных */
  .item {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
  
  /* Увеличение touch target для мобильных */
  .msg-reaction-more {
    min-width: 28px;
    min-height: 28px;
    padding: 4px 6px;
    font-size: 12px;
  }
  
  /* Улучшение для длинных сообщений */
  .text {
    max-width: calc(100vw - 120px);
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
  
  /* Оптимизация изображений для мобильных */
  .images img {
    max-width: calc(100vw - 120px);
    height: auto;
  }

  /* Оптимизация emoji bar для мобильных */
  .msg-ctx-emoji-bar {
    min-width: 140px;
    max-width: 180px;
    padding: 4px 8px;
  }

  .msg-ctx-emoji {
    font-size: 20px;
    padding: 3px 4px;
  }

  /* Улучшение контекстного меню для мобильных */
  .msg-ctx-menu {
    min-width: 140px;
    max-width: 180px;
  }

  .msg-ctx-action {
    padding: 0.6rem 0.6rem;
    font-size: 13px;
  }
}

/* Очень маленькие экраны */
@media (max-width: 480px) {
  .text {
    max-width: calc(100vw - 100px);
  }
  
  .images img {
    max-width: calc(100vw - 100px);
  }

  .msg-ctx-emoji-bar {
    min-width: 120px;
    max-width: 160px;
  }

  .msg-ctx-menu {
    min-width: 120px;
    max-width: 160px;
  }
}
</style>

<style>
/* Message quote block — inherits incoming message bg */
.msg-quote {
  border-left: 3px solid rgba(70, 127, 207, 0.6);
  padding: 4px 8px 2px 8px;
  margin-bottom: 2px;
  border-radius: 2px;
  display: block;
  background: rgba(0, 0, 0, 0.04);
}

.item.sent .msg-quote {
  background: rgba(255, 255, 255, 0.15);
  border-left-color: rgba(255, 255, 255, 0.5);
}

.item.inbox .msg-quote {
  background: rgba(0, 0, 0, 0.06);
}

/* Кликабельные цитаты */
.msg-quote.clickable-quote {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.msg-quote.clickable-quote:hover {
  background: rgba(70, 127, 207, 0.1);
}

.item.sent .msg-quote.clickable-quote:hover {
  background: rgba(255, 255, 255, 0.25);
}

.item.inbox .msg-quote.clickable-quote:hover {
  background: rgba(0, 0, 0, 0.08);
}

/* Подсветка найденного сообщения */
.highlighted-message {
  animation: highlightPulse 2s ease-in-out;
  background-color: rgba(70, 127, 207, 0.15);
}

@keyframes highlightPulse {
  0% {
    background-color: rgba(70, 127, 207, 0.18);
  }
  15% {
    background-color: rgba(70, 127, 207, 0.15);
  }
  40% {
    background-color: rgba(70, 127, 207, 0.12);
  }
  70% {
    background-color: rgba(70, 127, 207, 0.06);
  }
  100% {
    background-color: transparent;
  }
}

/* Иконки в цитатах */
.msg-quote .fe {
  font-size: 12px;
  vertical-align: middle;
  margin-right: 4px;
}

.msg-quote .fe.fe-image {
  color: #6c757d;
}

/* Медиа-цитаты с улучшенной стилизацией */
.msg-quote .media-quote {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #6c757d;
  font-weight: 500;
}

.msg-quote .media-quote .fe {
  font-size: 11px;
  opacity: 0.8;
  flex-shrink: 0;
}

/* Цитата поста ленты внутри сообщения (ответ на пост) */
.msg-quote.post-quote {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  margin-bottom: 4px;
}

.msg-quote.post-quote .post-quote-thumb {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
}

.msg-quote.post-quote .post-quote-body {
  min-width: 0;
}

.msg-quote.post-quote .post-quote-author {
  font-size: 12px;
  font-weight: 600;
  color: #2c63b0;
}

.item.sent .msg-quote.post-quote .post-quote-author {
  color: #fff;
  opacity: 0.95;
}

.msg-quote.post-quote .post-quote-text {
  font-size: 12px;
  opacity: 0.85;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Тёмная тема: inbox-цитаты — видимая поверхность (см. референс
   .conversation-input .input-group в vue-messages.css) */
:is(.dark, .theme-dark, body.dark-theme, body.dark-mode) .item.inbox .msg-quote {
  background: rgba(255, 255, 255, .08);
}

:is(.dark, .theme-dark, body.dark-theme, body.dark-mode)
  .item.inbox .msg-quote.post-quote .post-quote-author {
  color: #8ba9f0;
}

/* Доступность для скринридеров */
.msg-quote .media-quote .fe[aria-hidden="true"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ===== Emoji pop-in animation (shared by inline reactions) ===== */
@keyframes emoji-pop-in {
  0%   { opacity: 0; transform: scale(0) translateY(6px); }
  100% { opacity: 1; transform: scale(1) translateY(0); }
}

/* Indicator transition */
.indicator-fade-enter-active,
.indicator-fade-leave-active {
  transition: all 0.3s ease;
}

.indicator-fade-enter-from,
.indicator-fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* ===== Message delete animation (soft delete with _deletedLocally) ===== */
.item-deleted {
  animation: message-delete-shrink 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  pointer-events: none;
}

@keyframes message-delete-shrink {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  60% {
    opacity: 0.5;
    transform: scale(0.92);
  }
  100% {
    opacity: 0.25;
    transform: scale(0.88);
    filter: grayscale(0.7);
  }
}

/* Deleted text bubble styling */
.message-deleted {
  transition: all 0.35s ease;
  font-style: italic;
  opacity: 0.7;
}

/* ===== Blur overlay — constrained to conversation-items bounds ===== */
.msg-ctx-blur-layer {
  position: absolute;
  inset: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  cursor: pointer;
}

/* Active message — lifted above blur overlay */
.item.ctx-menu-active {
  position: relative;
  z-index: 1041; /* above blur (999), below popup (1042) */
}

.item.ctx-menu-active .text,
.item.ctx-menu-active .gift-message-card,
.item.ctx-menu-active .images {
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
}

/* ===== Popup container (emoji bar + actions card) ===== */
.msg-ctx-popup {
  position: absolute;
  z-index: 1042;
  display: flex;
  flex-direction: column;
  gap: 4px;
  pointer-events: auto;
  will-change: transform, opacity;
}

/* Меню действий — ближним к сообщению краем: при открытии снизу меню идёт первым */
.msg-ctx-popup:not(.above) .msg-ctx-menu {
  order: -1;
}

/* ===== Emoji bar ===== */
.msg-ctx-emoji-bar {
  display: flex;
  align-items: center;
  gap: 2px;
  border-radius: 4px;
  padding: 6px 12px;
  user-select: none;
  -webkit-user-select: none;
  width: 100%;
  min-width: 160px;
  max-width: 200px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
}

.msg-ctx-emoji-bar::-webkit-scrollbar {
  display: none;
}

.msg-ctx-emoji {
  background: none;
  border: none;
  font-size: 24px;
  padding: 4px 5px;
  border-radius: 50%;
  cursor: pointer;
  line-height: 1;
  flex-shrink: 0;
  scroll-snap-align: center;
  transition: transform 0.12s cubic-bezier(0.34, 1.56, 0.64, 1);
  animation: emoji-pop-in 0.2s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

.msg-ctx-emoji:hover { transform: scale(1.3); }
.msg-ctx-emoji:active { transform: scale(0.85); }

/* ===== Actions card ===== */
.msg-ctx-menu {
  background: var(--ctx-menu-bg, #fff);
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.14);
  min-width: 160px;
  max-width: 200px;
  padding: 0;
  user-select: none;
  -webkit-user-select: none;
}

.msg-ctx-divider {
  height: 1px;
  background: var(--ctx-menu-divider, rgba(0, 0, 0, 0.07));
  margin: 2px 12px;
}

.msg-ctx-action {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.75rem;
  text-decoration: none;
  border-radius: 12px;
  transition: background-color 0.15s ease;
  width: 100%;
  max-width: 320px;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  background: none;
  border: none;
  font-size: 14px;
  color: var(--ctx-menu-text, #333);
  cursor: pointer;
  gap: 10px;
}

.msg-ctx-action:hover { background: var(--ctx-menu-hover, rgba(0, 0, 0, 0.04)); }
.msg-ctx-action:active { background: var(--ctx-menu-active, rgba(0, 0, 0, 0.08)); }

.msg-ctx-action i {
  font-size: 15px;
  opacity: 0.6;
  width: 18px;
  text-align: center;
}

.msg-ctx-action-danger { color: #cd201f; }
.msg-ctx-action-danger i { opacity: 0.8; }

/* ===== Popup appear transition ===== */
.ctx-menu-appear-enter-active {
  transition: opacity 0.12s ease-out, transform 0.18s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.ctx-menu-appear-leave-active {
  transition: opacity 0.08s ease-in, transform 0.08s ease-in;
}
.ctx-menu-appear-enter-from {
  opacity: 0;
  transform: scale(0.8) translateY(8px);
}
.ctx-menu-appear-leave-to {
  opacity: 0;
  transform: scale(0.9) translateY(4px);
}

/* ===== Blur transition ===== */
.ctx-blur-enter-active { transition: opacity 0.15s ease-out; }
.ctx-blur-leave-active { transition: opacity 0.12s ease-in; }
.ctx-blur-enter-from,
.ctx-blur-leave-to { opacity: 0; }

/* ===== CSS Custom Properties: Light theme (default) ===== */
.conversation-items {
  --ctx-menu-bg: #fff;
  --ctx-menu-text: #333;
  --ctx-menu-divider: rgba(0, 0, 0, 0.07);
  --ctx-menu-hover: rgba(0, 0, 0, 0.04);
  --ctx-menu-active: rgba(0, 0, 0, 0.08);

  /* Reaction variables */
  --msg-reaction-bg: #fffffff2;
  --msg-reaction-color: inherit;
  --msg-reaction-shadow: 0 1px 3px #0000001a;
  --msg-reaction-hover-bg: #fffffff2;
  --msg-reaction-hover-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  --msg-reaction-count-color: #333;
}

/* ===== CSS Custom Properties: Dark theme ===== */
body.dark .conversation-items,
body.dark-mode .conversation-items,
body.dark-theme .conversation-items,
.theme-dark .conversation-items {
  --ctx-menu-bg: #303040;
  --ctx-menu-text: #e0e0e0;
  --ctx-menu-divider: rgba(255, 255, 255, 0.08);
  --ctx-menu-hover: rgba(255, 255, 255, 0.06);
  --ctx-menu-active: rgba(255, 255, 255, 0.1);

  /* Reaction variables */
  --msg-reaction-bg: rgba(48, 48, 64, 0.95);
  --msg-reaction-color: #edf2f9;
  --msg-reaction-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  --msg-reaction-hover-bg: rgba(60, 60, 80, 0.95);
  --msg-reaction-hover-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
  --msg-reaction-count-color: #edf2f9;
}

/* Auto theme follows system preference */
@media (prefers-color-scheme: dark) {
  body.auto:not(.theme-dark):not(.theme-light) .conversation-items {
    --ctx-menu-bg: #303040;
    --ctx-menu-text: #e0e0e0;
    --ctx-menu-divider: rgba(255, 255, 255, 0.08);
    --ctx-menu-hover: rgba(255, 255, 255, 0.06);
    --ctx-menu-active: rgba(255, 255, 255, 0.1);

    --msg-reaction-bg: rgba(48, 48, 64, 0.95);
    --msg-reaction-color: #edf2f9;
    --msg-reaction-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
    --msg-reaction-hover-bg: rgba(60, 60, 80, 0.95);
    --msg-reaction-hover-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    --msg-reaction-count-color: #edf2f9;
  }
}

body.dark .msg-ctx-blur-layer,
body.dark-mode .msg-ctx-blur-layer,
body.dark-theme .msg-ctx-blur-layer,
.theme-dark .msg-ctx-blur-layer {
  background: rgba(0, 0, 0, 0.35);
}

body.dark .msg-ctx-action-danger,
body.dark-mode .msg-ctx-action-danger,
body.dark-theme .msg-ctx-action-danger,
.theme-dark .msg-ctx-action-danger {
  color: #f44;
}

body.dark .item.ctx-menu-active .text,
body.dark .item.ctx-menu-active .gift-message-card,
body.dark .item.ctx-menu-active .images,
body.dark-theme .item.ctx-menu-active .text,
body.dark-theme .item.ctx-menu-active .gift-message-card,
body.dark-theme .item.ctx-menu-active .images,
.theme-dark .item.ctx-menu-active .text,
.theme-dark .item.ctx-menu-active .gift-message-card,
.theme-dark .item.ctx-menu-active .images {
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.4);
}
</style>
